import { Button, Dropdown, Icon, Menu } from 'antd'
import React, { FC, useState } from 'react'
import { resellerService, serviceProviderService } from '../../services'
import { ReportType, RequestErrorInterface, RequestErrorObject } from '../../types'
import handleError from '../handleError'
import formatReportName from './formatReportName'

interface CsvReportProps {
	entityName: string
	entityId: number
	type: 'serviceprovider' | 'reseller'
}

const CsvReport: FC<CsvReportProps> = ({ entityId, entityName, type }) => {
	const [downloadLoading, setDownloadLoading] = useState<boolean>(false)

	const handleReportError = (error: RequestErrorInterface): RequestErrorObject => {
		const source = 'CSV Report Error'
		const base = { source, status: error.response.status }

		return { ...base, description: 'There was an unexpected problem when attempting to download your report' }
	}

	const downloadReport = async (reportType: ReportType): Promise<void> => {
		setDownloadLoading(true)
		try {
			const { data } =
				type === 'reseller' ? await resellerService.getCsvReport(entityId, reportType) : await serviceProviderService.getCsvReport(entityId, reportType)
			const csvContent = `data:text/csv;charset=utf-8,${data}`
			const name = formatReportName(entityName)
			const date = new Date()
			const dateString = date.toLocaleDateString().replaceAll('/', '')
			const timeString = date.toLocaleTimeString().replaceAll(':', '')

			const link = document.createElement('a')
			link.setAttribute('href', csvContent)
			link.setAttribute('id', 'downloadReport')
			link.setAttribute('download', encodeURI(`${name}_${reportType}_${dateString}_${timeString}.csv`))
			document.body.appendChild(link)
			link.click()
			link.remove()
		} catch (error) {
			handleError(error, handleReportError)
		}
		setDownloadLoading(false)
	}

	const downloadOptions = (
		<Menu>
			<Menu.Item key='license' onClick={() => downloadReport('license')}>
				License
			</Menu.Item>
			<Menu.Item key='subscriber' onClick={() => downloadReport('subscriber')}>
				Subscriber
			</Menu.Item>
		</Menu>
	)

	return (
		<Dropdown overlay={downloadOptions}>
			<Button loading={downloadLoading}>
				<Icon type='download' /> Download Report <Icon type='down' />
			</Button>
		</Dropdown>
	)
}

export default CsvReport
